import React, { useRef, useState, useEffect, useMemo } from "react";
import { Box } from "@mui/material";
import _ from "lodash";
import { useIntl } from "react-intl";
import KolTable from "./components/KolTable";

const KolLibrary = () => {
  const { formatMessage } = useIntl();

  return (
    <KolTable
      pageTitleKey="kolLibrary.title"
      pageDescriptionKey="kolLibrary.subtitle"
    />
  );
};

export default KolLibrary;
